import { isClient } from './utils/tools';

// 使用 Symbol.for 创建或获取全局唯一的 Symbol
export var SHARED_SPOT_SYMBOLS_DATA = Symbol.for('sharedSpotSymbolsData');

// 共享 window 对象
var sharedWindow = isClient ? window.top || window : {};

// 如果 window 上没有共享数据，就初始化
if (isClient && !sharedWindow[SHARED_SPOT_SYMBOLS_DATA]) {
  sharedWindow[SHARED_SPOT_SYMBOLS_DATA] = {
    symbolsPromise: null,
    // 币对列表Promise
    retryInProgress: false,
    // 是否重试中
    cacheSymbolsData: null,
    // 缓存的完整币对列表+版本号
    cacheSymbolsDataCdn: null,
    // 缓存的CDN币对列表+lastModifiedTime
    getSymbolsRetryTimes: 0,
    // 获取币对列表重试次数
    BACKOFF_ID: 'GET_SYMBOLS' // backoff重试的指针
  };
}

// 共享数据
export var sharedData = sharedWindow[SHARED_SPOT_SYMBOLS_DATA] || {};